import { mapActions } from 'vuex'

export const reportsMixin2 = {
  data() {
    return {
      searchVehicleValue: null,
      searchAction: false,
      searchVehicleResult: [],
      showOk: false,
      showStop: false,
      menu1: false,
      dates1: [],
      dates2: [],
      time1Date1: null,
      time2Date1: null,
      time1Date2: null,
      time1Date1Menu: false,
      time2Date1Menu: false,
      time1Date2Menu: false,
      menu2: false,
      showClearForm: false,
      fromDateAllowed: '2020-04-30'
    }
  },
  computed: {
    time1Date1IsToday() {
      let result = false
      if (this.time1Date1 !== null) {
        let today = this.$moment.now()
        today = this.$moment(today).format('YYYY-MM-DD')
        result = this.$moment(today).isSame(this.dates1[0])
      }
      return result
    },
    reportTimeDisabled() {
      let result = true
      if (this.dates1.length === 1 && this.dates2.length === 0 && this.time1Date1 && this.time2Date1) result = false
      else if (this.dates2.length === 1 && this.time1Date1 && this.time1Date2) result = false
      return result
    }
  },
  methods: {
    ...mapActions(['searchVehicleAction']),
    initData() {
      this.searchVehicleValue = null
      this.searchAction = false
      this.searchVehicleResult = []
      this.showOk = false
      this.showStop = false
      this.menu1 = false
      this.dates1 = []
      this.dates2 = []
      this.time1Date1 = null
      this.time2Date1 = null
      this.time1Date2 = null
      this.time1Date1Menu = false
      this.time2Date1Menu = false
      this.time1Date2Menu = false
      this.menu2 = false
    },
    searchVehicle() {
      if (this.searchVehicleValue !== null) {
        this.searchAction = false
        this.searchVehicleAction(this.searchVehicleValue)
          .then(result => {
            this.searchAction = true
            this.searchVehicleResult = result
            if (this.searchVehicleResult.length > 0) {
              this.showOk = true
              this.showStop = false
            } else {
              this.showOk = false
              this.showStop = true
            }
          })
      }
    },
    allowedDates1(date) {
      // console.log('FROM DATE ALLOWED', this.fromDateAllowed)
      let today = this.$moment.now()
      let datesResult = this.$moment(date).isAfter(this.fromDateAllowed) && this.$moment(date).isBefore(today)
      today = this.$moment(today).format('YYYY-MM-DD')

      if (this.dates1.length === 1) datesResult = date === this.dates1[0]

      return datesResult
    },
    changesOnDate1() {
      this.dates2 = []
      this.time1Date1 = null
      this.time1Date2 = null
    },
    time1Date1IsTodayCheck() {
      let today = this.$moment.now()
      today = this.$moment(today).format('YYYY-MM-DD')
      const result = this.$moment(today).isSame(this.dates1[0])
      return result
    },
    allowedHours0(value) {
      let result = true
      const today = this.$moment.now()
      const currentHour = Number(this.$moment(today).format('HH'))
      if (this.time1Date1IsTodayCheck()) result = value <= currentHour
      return result
    },
    allowedMinutes0(value) {
      let result = true
      if (this.time1Date1IsTodayCheck()) {
        const today = this.$moment.now()
        const currentHour = Number(this.$moment(today).format('HH'))
        const currentMinute = Number(this.$moment(today).format('mm'))

        const date0Time1 = this.$moment(`${this.dates1[0]} ${this.time1Date1}`)
        const hour1 = Number(this.$moment(date0Time1).format('HH'))

        result = hour1 === currentHour
          ? value <= currentMinute
          : true
      }
      return result
    },
    changesOnTime1Date1() {
      this.time2Date1 = null
      this.time1Date2 = null
    },
    clearTime1Date1() {
      this.dates2 = []
      this.time1Date2 = null
    },
    acceptTime10() {
      this.$refs.time1Date1Menu.save(this.time1Date1)
      const myDate = `${this.dates1[0]} ${this.time1Date1}`
      this.time2Date1 = this.$moment(myDate).add(1, 'm').format('HH:mm')
    },
    allowedHours1(value) {
      if (this.time2Date1 === null) this.time2Date1 = this.time1Date1

      const myDate = `${this.dates1[0]} ${this.time1Date1}`
      const selectedHour1 = this.time1Date1.split(':')
      const amountOfHours = 24 - Number(selectedHour1[0])
      const allowedHoursArray = []
      for (let i = 0; i < amountOfHours; i++) {
        const h = this.$moment(myDate).add(i, 'hours').format('H')
        allowedHoursArray.push(Number(h))
      }

      const today = this.$moment.now()
      const currentHour = Number(this.$moment(today).format('HH'))

      const isIn = this.time1Date1IsTodayCheck()
        ? allowedHoursArray.filter(item => item === value && item <= currentHour)
        : allowedHoursArray.filter(item => item === value)

      const result = isIn.length > 0
      return result
    },
    allowedMinutes1(value) {
      if (this.time2Date1 !== null) {
        const today = this.$moment.now()
        const currentHour = Number(this.$moment(today).format('HH'))
        const currentMinute = Number(this.$moment(today).format('mm'))

        const selectedHour2 = this.time2Date1.split(':')
        const selectedHour1 = this.time1Date1.split(':')
        const hour1 = Number(selectedHour1[0])
        const minute1 = Number(selectedHour1[1])

        if (Number(selectedHour2[0]) === hour1) {
          const result = hour1 === Number(currentHour) && this.time1Date1IsTodayCheck()
            ? value > minute1 && value <= currentMinute
            : value > minute1
          return result
        } else if (
          Number(selectedHour2[0]) === Number(currentHour) &&
          this.time1Date1IsTodayCheck()
        ) {
          const result = value <= currentMinute
          return result
        }
      }
      return true
    },
    allowedDates2(date) {
      let today = this.$moment.now()
      today = this.$moment(today).format('YYYY-MM-DD')
      if (today === this.dates1[0]) return false

      const selectedDate = this.$moment(this.dates1[0])
      const differenceTime = Math.abs(selectedDate.diff(today, 'hours'))

      const addDay = differenceTime <= 24 ? 1 : 2

      let datesResult
      if (addDay === 1 && date === today) datesResult = true
      else if (addDay === 2) {
        if (this.dates2.length === 1) {
          datesResult = date === this.dates2[0]
        } else {
          const dayAfter1 = this.$moment(this.dates1[0]).add(1, 'days').format('YYYY-MM-DD')
          const dayAfter2 = this.$moment(this.dates1[0]).add(2, 'days').format('YYYY-MM-DD')
          datesResult = date === dayAfter1 || date === dayAfter2
        }
      }
      return datesResult
    },
    changesOnDate2() {
      this.time1Date2 = null
    },
    allowedHours2(value) {
      const initDay = this.$moment(this.dates1[0])
      const finalDay = this.$moment(this.dates2[0])
      const diffHours = Math.abs(finalDay.diff(initDay, 'hours'))

      const selectedHour1 = this.time1Date1.split(':')
      let result
      const today = this.$moment.now()
      const currentHour = Number(this.$moment(today).format('HH'))
      if (diffHours === 24) {
        result = this.date2IsTodayCheck()
          ? value <= currentHour
          : true
      } else {
        if (this.date2IsTodayCheck()) {
          result = currentHour <= Number(selectedHour1[0])
            ? value <= currentHour
            : value <= Number(selectedHour1[0])
        } else result = value <= Number(selectedHour1[0])
      }
      return result
    },
    allowedMinutes2(value) {
      let result = true
      const initDay = this.$moment(this.dates1[0])
      const finalDay = this.$moment(this.dates2[0])
      const diffHours = Math.abs(finalDay.diff(initDay, 'hours'))
      if (this.time1Date2 !== null) {
        const selectedHour1 = this.time1Date1.split(':')
        const selectedHour2 = this.time1Date2.split(':')
        const hour1 = Number(selectedHour1[0])
        const hour2 = Number(selectedHour2[0])
        const minute1 = Number(selectedHour1[1])
        if (this.date2IsTodayCheck()) {
          const today = this.$moment.now()
          const currentHour = Number(this.$moment(today).format('HH'))
          const currentMinute = Number(this.$moment(today).format('mm'))
          if (hour2 === hour1 && diffHours > 24) result = false
          else {
            result = currentHour === hour2
              ? value <= currentMinute
              : true
          }
        } else if (hour2 === hour1 && diffHours > 24) {
          result = value <= minute1
        }
      }
      return result
    },
    date2IsTodayCheck() {
      let today = this.$moment.now()
      today = this.$moment(today).format('YYYY-MM-DD')
      const result = this.$moment(today).isSame(this.dates2[0])
      return result
    },
    clickHourTime1Date2(value) {
      // console.log('clickHourTime1Date2', this.time1Date2)
      this.time1Date2 = this.time1Date2 === null ? `${value}:00` : this.time1Date2
    },
    clickMinuteTime1Date2() {
      console.log('clickMinuteTime1Date2')
    },
    clearForm() {
      this.showClearForm = false
      this.initData()
    },
    downloadReport() {
      this.showClearForm = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/reportsMixin2.js